import { jsxs, jsx } from "react/jsx-runtime";
import { Stack, Text, Box, Inline, Notice, ButtonIcon, IconAdd } from "braid-design-system";
import { useState, useEffect, useCallback } from "react";
import { useShouldAnimateSkill, SKILL_TAGS_STACK_SPACE, SKILL_TAGS_INLINE_SPACE } from "../Skills/Skills.mjs";
import { clearGutter } from "./SuggestedSkills.css.mjs";
import { tagAnimation } from "../Skills/Skills.css.mjs";
const SuggestedSkills = ({
  suggestedSkills,
  onClick,
  hasMaxSkills
}) => {
  const hasSuggestedSkills = suggestedSkills.length !== 0;
  const [showMaxSkillsMessage, setShowMaxSkillsMessage] = useState(false);
  useEffect(() => {
    if (showMaxSkillsMessage && !hasMaxSkills) {
      setShowMaxSkillsMessage(false);
    }
  }, [hasMaxSkills, showMaxSkillsMessage]);
  const shouldAnimateSkill = useShouldAnimateSkill(suggestedSkills);
  const onAdd = useCallback(
    (skill) => () => {
      if (!showMaxSkillsMessage && hasMaxSkills) {
        setShowMaxSkillsMessage(true);
      } else if (!hasMaxSkills) {
        if (showMaxSkillsMessage) {
          setShowMaxSkillsMessage(false);
        }
        onClick(skill);
      }
    },
    [hasMaxSkills, onClick, showMaxSkillsMessage]
  );
  return /* @__PURE__ */ jsxs(Stack, { space: SKILL_TAGS_STACK_SPACE, children: [
    /* @__PURE__ */ jsx(Text, { weight: "strong", children: "Suggested skills based on your career history" }),
    hasSuggestedSkills ? /* @__PURE__ */ jsxs(Stack, { space: "xsmall", children: [
      /* @__PURE__ */ jsx(Box, { "data-testid": "suggested-skills", children: /* @__PURE__ */ jsx(Inline, { space: SKILL_TAGS_INLINE_SPACE, component: "ul", children: suggestedSkills.slice(0, 5).map((skill, i) => {
        const showScaleAnimation = shouldAnimateSkill(skill);
        const tagStyles = { [tagAnimation]: showScaleAnimation };
        return /* @__PURE__ */ jsx(
          Box,
          {
            component: "li",
            className: tagStyles,
            children: /* @__PURE__ */ jsx(
              SuggestionTag,
              {
                id: `suggested-skill-${i}`,
                onAdd: onAdd(skill),
                addLabel: `Add skill ${skill.keyword.text}`,
                children: `${skill.keyword.text}`
              }
            )
          },
          `${skill.keyword.text}-${skill.keyword.ontologyId}-${i}`
        );
      }) }) }),
      showMaxSkillsMessage ? /* @__PURE__ */ jsx(Notice, { tone: "critical", children: /* @__PURE__ */ jsx(Text, { tone: "critical", children: "You can't have more than 50 skills" }) }) : null
    ] }) : /* @__PURE__ */ jsx(Notice, { tone: "positive", children: /* @__PURE__ */ jsx(Text, { tone: "positive", children: "You've added all suggestions!" }) })
  ] });
};
const AddButton = ({ id, label = "Add", onClick }) => /* @__PURE__ */ jsx(
  ButtonIcon,
  {
    bleed: false,
    icon: /* @__PURE__ */ jsx(IconAdd, {}),
    id,
    label,
    onClick,
    tone: "neutral",
    variant: "transparent"
  }
);
const SuggestionTag = ({
  children,
  id,
  onAdd,
  addLabel
}) => /* @__PURE__ */ jsx(Box, { id, display: "flex", children: /* @__PURE__ */ jsxs(
  Box,
  {
    display: "flex",
    minWidth: 0,
    alignItems: "center",
    background: "infoLight",
    paddingLeft: "small",
    borderRadius: "full",
    children: [
      /* @__PURE__ */ jsx(Box, { minWidth: 0, title: children, children: /* @__PURE__ */ jsx(Text, { baseline: false, maxLines: 1, children }) }),
      /* @__PURE__ */ jsx(
        Box,
        {
          flexShrink: 0,
          display: "flex",
          className: clearGutter,
          children: /* @__PURE__ */ jsx(AddButton, { id: `${id}-add`, label: addLabel, onClick: onAdd })
        }
      )
    ]
  }
) });
export {
  SuggestedSkills
};
